module.exports = __webpack_public_path__ + "media/img/manual-testing/testing-diagram-180c9b798a0017552416122b913b3fa9.svg";